import SectionStages from './section-stages';

export default SectionStages;
